module.exports = __webpack_public_path__ + "assets/img/help_tittle.7c2153f1.svg";